angular.module('bmsApp.settings')
	.controller('BusinessDetailCtrl',
		function ($scope, $log, notify, ContactDetailTypeSvc, BusinessDetailSvc, $q, $state, FranchiseSvc, SiteSvc) {

			$scope.business = {
				phoneContacts: [],
				emailContacts: [],
				webContacts: []
			};
			$scope.formValidator = {};
			$scope.formvalidatorconfig = {
				submitHandler: function (form) {
					$scope.submit($scope.business);
				},
				rules: {
					postcode: {
						postcodeUK: true
					}
				}
			};
			$scope.loaded = false;

			var promises = [];
			promises.push(ContactDetailTypeSvc.indexRaw());
			promises.push(FranchiseSvc.businessAddressTypes());
			promises.push(FranchiseSvc.read());

			$q.all(promises)
				.then(function (responses) {
					$scope.contact_types = responses[0].data.types;
					$scope.address_types = responses[1].data.business_address_type_collection;

					if ($state.is('main.settings.businessDetails')) {
						$scope.franchise = responses[2].data.franchise;
					}
					$scope.loaded = true;
				}, function (error) {
					$scope.errors = error;
				});

			$scope.addAnotherContact = function (type) {
				$scope.franchise.business_contact_details.push({});
			};

			$scope.addAnotherAddress = function (index) {
				$scope.franchise.business_addresses.push({});
			};

			$scope.removeAddress = function(address, index) {
				if (address.id) {
					if (address.id == $scope.franchise.primary_address_id) {
						notify({
							message: 'You cannot remove this address as it is currently set as the primary address',
							classes: 'error'
						});
					}
					else {
						angular.extend(address, {
							deleted: true
						});
					}
				}
				else {
					$scope.franchise.business_addresses.splice(index, 1);
				}
			};

			$scope.removeContact = function(contact, index) {
				if (contact.id) {
					angular.extend(contact, {
						deleted: true
					});
				}
				else {
					$scope.franchise.business_contact_details.splice(index, 1);
				}
			};

			$scope.addressLookup = function(_address) {
				return SiteSvc.lookup({postcode: _address.postcode_lookup, houseNo: _address.houseno_lookup}).then(function(response) {
					_address.addressList = response.data.addresses;
					if (_address.addressList.length === 1) {
						let address = _address.addressList[0];
						_address.address_1 = address.line_1 || '';
						_address.address_2 = address.line_2 || '';
						_address.address_3 = address.line_3 || '';
						_address.city = address.city || '';
						_address.county = address.county || '';
						_address.postcode = address.postcode || '';
						_address.showLookup = false;
					}
				}, function() {
					notify({
						message: 'Address not found',
						classes: 'error',
					});
				});
			};

			$scope.addressChanged = function(address, _address) {
				_address.address_1 = address.line_1;
				_address.address_2 = address.line_2;
				_address.address_3 = address.line_3;
				_address.city = address.city;
				_address.county = address.county;
				_address.postcode = address.postcode;
				_address.showLookup = false;
			};

			$scope.submit = function (business) {
				FranchiseSvc.save($scope.franchise)
					.then(function (response) {
						notify({
							message: 'Successfully saved'
						});

					}, function (error) {
						$scope.errors = error;
					});

			}

		});
